// Custom confirmation modal that matches the app's modal notification style
// Intercepts form submissions and link clicks with data-turbo_confirm or data-custom-confirm attribute

(function() {
  let overlayEl = null;
  let pendingCallback = null;

  function showModal(title, message, callback) {
    // Remove existing modal if present
    const existing = document.getElementById('custom-confirm-modal');
    if (existing) existing.remove();

    pendingCallback = callback;

    // Create modal overlay
    overlayEl = document.createElement('div');
    overlayEl.className = 'fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm transition-all duration-300';
    overlayEl.style.opacity = '0';

    const modal = document.createElement('div');
    modal.className = 'bg-white border-2 border-black p-8 md:p-10 max-w-lg w-full shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] flex flex-col gap-6 animate-in fade-in zoom-in duration-200';

    // Content div
    const contentDiv = document.createElement('div');
    const titleEl = document.createElement('h3');
    titleEl.className = 'text-2xl font-black tracking-tighter uppercase mb-3 text-black';
    titleEl.textContent = title;
    const messageEl = document.createElement('p');
    messageEl.className = 'text-gray-600 font-serif text-lg leading-relaxed';
    messageEl.textContent = message;
    contentDiv.appendChild(titleEl);
    contentDiv.appendChild(messageEl);

    // Buttons div
    const buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'flex justify-end gap-4 mt-4';

    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'px-6 py-3 text-sm font-bold tracking-widest uppercase text-gray-500 hover:text-black transition-colors cursor-pointer';
    cancelBtn.textContent = document.body.dataset.confirmCancel || 'Cancel';

    const okBtn = document.createElement('button');
    okBtn.type = 'button';
    okBtn.className = 'px-8 py-3 text-sm font-bold tracking-widest uppercase bg-black text-white hover:bg-gray-800 transition-colors shadow-sm hover:shadow-md cursor-pointer';
    okBtn.textContent = document.body.dataset.confirmOk || 'Confirm';

    buttonsDiv.appendChild(cancelBtn);
    buttonsDiv.appendChild(okBtn);

    modal.appendChild(contentDiv);
    modal.appendChild(buttonsDiv);
    overlayEl.appendChild(modal);
    document.body.appendChild(overlayEl);

    const closeModal = (answer) => {
      const el = overlayEl;
      if (!el) return;
      overlayEl = null;
      el.style.opacity = '0';
      modal.style.transform = 'scale(0.95)';
      setTimeout(() => {
        if (el && el.parentNode) {
          el.remove();
        }
      }, 300);

      if (pendingCallback) {
        pendingCallback(answer);
        pendingCallback = null;
      }
    };

    cancelBtn.addEventListener('click', function(e) { e.stopPropagation(); closeModal(false); });
    okBtn.addEventListener('click', function(e) { e.stopPropagation(); closeModal(true); });

    // Close on overlay click (not modal click)
    overlayEl.addEventListener('click', function(e) {
      if (e.target === overlayEl) closeModal(false);
    });

    // Animate in
    requestAnimationFrame(() => {
      overlayEl.style.opacity = '1';
      modal.style.transform = 'scale(1)';
    });
  }

  function init() {
    // Handle elements with data-turbo_confirm by replacing the behavior
    document.querySelectorAll('[data-turbo_confirm]').forEach(function(element) {
      const message = element.getAttribute('data-turbo_confirm');
      // Support optional custom title via data-confirm-title, otherwise split message on | for "TITLE|message" format
      let title = document.body.dataset.confirmTitle || 'CONFIRM ACTION';
      let modalMessage = message;

      if (element.hasAttribute('data-confirm-title')) {
        title = element.getAttribute('data-confirm-title');
      } else if (message.includes('|')) {
        const parts = message.split('|');
        title = parts[0].trim();
        modalMessage = parts.slice(1).join('|').trim();
      }

      element.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        showModal(title, modalMessage, function(confirmed) {
          if (confirmed) {
            // If it's a form button, submit the form
            if (element.form) {
              element.form.requestSubmit();
            } else if (element.tagName === 'A') {
              window.location.href = element.href;
            }
          }
        });
      });
    });

    // Handle elements with data-custom-confirm (alternative attribute)
    document.querySelectorAll('[data-custom-confirm]').forEach(function(element) {
      const message = element.getAttribute('data-custom-confirm');
      let title = document.body.dataset.confirmTitle || 'CONFIRM ACTION';
      let modalMessage = message;

      if (element.hasAttribute('data-confirm-title')) {
        title = element.getAttribute('data-confirm-title');
      } else if (message.includes('|')) {
        const parts = message.split('|');
        title = parts[0].trim();
        modalMessage = parts.slice(1).join('|').trim();
      }

      element.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        showModal(title, modalMessage, function(confirmed) {
          if (confirmed) {
            if (element.form) {
              element.form.requestSubmit();
            } else if (element.tagName === 'A') {
              window.location.href = element.href;
            }
          }
        });
      });
    });
  }

  // Initialize on page load and Turbo navigation
  document.addEventListener('turbo:load', init);
  document.addEventListener('DOMContentLoaded', init);
})();
